module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-5"
  }, [_c('div', {
    staticClass: "alert primary"
  }, [_c('div', {
    staticClass: "alert-text"
  }, [_c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("investment.name")) + ":")]), _vm._v(" " + _vm._s(_vm.investment.name) + "\n                           ")]), _vm._v(" "), _c('div', {
    staticClass: "font-md"
  }, [_c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("investment.email")) + ": ")]), _vm._v(_vm._s(_vm.investment.email) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-4 row"
  }, [_c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.wallet")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.walletAddress) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                         " + _vm._s(_vm.$t("investment.transaction")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.transaction) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.sendingAddress")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.sendingAddress) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.purchasingAmount")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.investment.purchasingAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.paymentType")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.investment.paymentType))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.sentTime")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.sentTime) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.recordTime")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.recordTime) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.averagePrice")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.averagePrice) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.purchasingAmountInUSD")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.purchasingAmountInUSD) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.bonusRate")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.bonusRate) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.bonus")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_vm._v("\n                        " + _vm._s(_vm.investment.bonus) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 fw-bold font-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("investment.totalIOB")) + "\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 mb-3"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.investment.totalIOB))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d217f16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/token/InvestmentData.vue
// module id = 424
// module chunks = 0